import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'progress-with-text',
  templateUrl: 'progress-with-text.html',
  styleUrls: ['progress-with-text.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProgressWithTextComponent {
  @Input() inputData : any;
}
